import React, { FunctionComponent } from 'react';
import Row from '@/components/layout/Row';
import Col from 'antd/lib/grid/col';
import LinkColumns from '@/components/landingPages/LinkColumns';
import { ILandingPageLink } from '@/pageGeneration/services/LandingPageService';

import styles from './LandingPageLinkIndex.module.scss';

interface IProps {
  items: ILandingPageLink[];
}

const LandingPageLinkIndex: FunctionComponent<IProps> = ({ items = [] }) => (
    <div className={styles.container}>
      <Row>
        <Col xs={24} sm={24} md={{ offset: 2, span: 20 }} lg={{ offset: 4, span: 16 }}>
          <Row gutter={[30, 0]}>
            <LinkColumns links={items} />
          </Row>
        </Col>
      </Row>
    </div>
  );

export default LandingPageLinkIndex;
